var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8001 0C12.7651 0 11.1001 1.6875 11.1001 3.75V56.25C11.1001 58.3125 12.7651 60 14.8001 60H51.8001C53.8351 60 55.5001 58.3125 55.5001 56.25V15L40.7001 0H14.8001Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4002 15H55.5002L40.7002 0V11.25C40.7002 13.3125 42.3652 15 44.4002 15Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4999 26.25L44.3999 15H55.4999V26.25Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1002 48.75C48.1002 49.7812 47.2677 50.625 46.2502 50.625H5.5502C4.5327 50.625 3.7002 49.7812 3.7002 48.75V30C3.7002 28.9688 4.5327 28.125 5.5502 28.125H46.2502C47.2677 28.125 48.1002 28.9688 48.1002 30V48.75Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7642 35.5256C11.7642 35.0306 12.149 34.4906 12.7687 34.4906H16.1857C18.1097 34.4906 19.8413 35.7956 19.8413 38.2969C19.8413 40.6669 18.1097 41.9869 16.1857 41.9869H13.7159V43.9669C13.7159 44.6269 13.3015 45 12.7687 45C12.2803 45 11.7642 44.6269 11.7642 43.9669V35.5256ZM13.7159 36.3788V40.1138H16.1857C17.1773 40.1138 17.9617 39.2269 17.9617 38.2969C17.9617 37.2488 17.1773 36.3788 16.1857 36.3788H13.7159Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7385 45C22.2501 45 21.7173 44.73 21.7173 44.0719V35.5556C21.7173 35.0175 22.2501 34.6256 22.7385 34.6256H26.1258C32.8857 34.6256 32.7377 45 26.259 45H22.7385ZM23.6709 36.4556V43.1719H26.1258C30.12 43.1719 30.2976 36.4556 26.1258 36.4556H23.6709Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1353 36.5756V38.9587H38.9075C39.4403 38.9587 39.9731 39.4987 39.9731 40.0219C39.9731 40.5169 39.4403 40.9219 38.9075 40.9219H35.1353V44.07C35.1353 44.595 34.7671 44.9981 34.2491 44.9981C33.5979 44.9981 33.2002 44.595 33.2002 44.07V35.5537C33.2002 35.0156 33.5998 34.6237 34.2491 34.6237H39.4421C40.0933 34.6237 40.4781 35.0156 40.4781 35.5537C40.4781 36.0337 40.0933 36.5738 39.4421 36.5738H35.1353V36.5756Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2501 50.625H11.1001V52.5H46.2501C47.2676 52.5 48.1001 51.6562 48.1001 50.625V48.75C48.1001 49.7812 47.2676 50.625 46.2501 50.625Z",
    fill: "#CAD1D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ced01fba.svg";
export { ForwardRef as ReactComponent };